export default __webpack_public_path__ + "static/media/tick.78863f32.svg";